import theme from '../../../themes/green';

const style = {
  wrapper: {
    width: '100%',
    height: 100,
    color: 'white',
    textAlign: 'center',
    position: 'relative',
    cursor: 'pointer',
  },
  activeWrapper: {
    backgroundColor: theme.pallete.hover,
  },
  contents: {
    height: '100%',
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  preview: {
    zIndex: 1,
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
  previewOverlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(71,97,102,0.6)',
  },
  required: {
    color: 'red',
    fontSize: 10,
  },
  selectedFiles: {
    fontSize: 10,
  },
};

export default style;



// WEBPACK FOOTER //
// ./src/components/UIKit/FileInput/styles.js